module.exports = {
  theme: process.env.REACT_APP_THEME,
  auth0domain: process.env.REACT_APP_AUTH0_DOMAIN,
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  catalogId: process.env.REACT_APP_CATALOG_ID,
  dataAdClient: process.env.REACT_APP_DATA_AD_CLIENT,
}
